import { jsx as i, jsxs as w } from "react/jsx-runtime";
import y from "react";
import { c as T } from "./index.CWkFp9WS.js";
import { p as ee, q as K, r as A, l as z, t as te, v as ne, F as oe, n as se, w as ae, x as le, u as ie, o as ce, f as ue, s as re, a as de, j as me, y as fe, d as ye, e as Fe, c as Ie, g as Se, m as he, h as De } from "./floating-ui.react.MkaYL6o7.js";
import { S as pe } from "./index.J3BKoY__.js";
import Me from "./ODSCheckmark.BoBwhUnX.js";
import ge from "./ODSNavigationRight.Da0xs0J9.js";
import { u as Oe } from "./scoped-color-scheme.D8FTJTjz.js";
import { u as J } from "./media-query.B9bznea_.js";
import '../assets/ODSFlyoutMenu.css';const be = (s) => {
  const { children: c, verticalOffset: a = 0, ...u } = s;
  return /* @__PURE__ */ i(ee, { children: /* @__PURE__ */ i(U, { verticalOffset: a, ...u, children: c }) });
};
be.displayName = "ODSFlyoutMenu";
const U = y.forwardRef((s, c) => {
  const {
    className: a,
    children: u,
    trigger: e,
    horizontalOffset: r,
    verticalOffset: d,
    openOnHover: D,
    size: p = "large",
    menuSize: M = "large",
    ...m
  } = s, F = we({
    horizontalOffset: r,
    verticalOffset: d,
    openOnHover: D,
    ...m
  }), {
    nodeId: t,
    parentId: l,
    open: f,
    setOpen: S,
    context: g,
    floatingStyles: O,
    hasFocusInside: x,
    getReferenceProps: b,
    refs: I,
    setHasFocusInside: o,
    elementsRef: n,
    labelsRef: N,
    getFloatingProps: $
  } = F, v = l != null, k = y.useContext(j), C = A(), E = K(), H = M ?? p;
  Re({ nodeId: t, parentId: l, tree: C, open: f, setOpen: S });
  const { colorScheme: L, colorMode: _ } = Oe(I.reference, [
    f
  ]), B = (h) => {
    h.altKey || h.ctrlKey || h.metaKey || h.key === "Escape" && (h.preventDefault(), h.stopPropagation(), S(!1), v && g.elements.domReference.focus());
  }, P = y.Children.map(
    u,
    (h) => y.cloneElement(
      h,
      {
        size: H
      }
    )
  );
  return /* @__PURE__ */ w(te, { id: t, children: [
    /* @__PURE__ */ i(
      pe,
      {
        ref: z([I.setReference, E.ref, c]),
        tabIndex: v ? (k == null ? void 0 : k.activeIndex) === E.index ? 0 : -1 : void 0,
        role: v ? "menuitem" : void 0,
        "data-open": f ? "" : void 0,
        "data-nested": v ? "" : void 0,
        "data-focus-inside": x ? "" : void 0,
        className: v ? "MenuItem" : "RootMenu",
        ...b({
          disabled: F.disabled,
          ...k == null ? void 0 : k.getItemProps({
            ...m,
            onFocus(h) {
              var R;
              (R = s.onFocus) == null || R.call(s, h), o(!1), k.setHasFocusInside(!0);
            }
          })
        }),
        children: e
      }
    ),
    /* @__PURE__ */ i(j.Provider, { value: F, children: /* @__PURE__ */ i(ne, { elementsRef: n, labelsRef: N, children: f && /* @__PURE__ */ i(oe, { children: /* @__PURE__ */ i(
      se,
      {
        context: g,
        modal: !1,
        initialFocus: v ? -1 : 0,
        returnFocus: !v,
        children: /* @__PURE__ */ i(
          "div",
          {
            ref: I.setFloating,
            className: T(
              "ODSFlyoutMenu-Content",
              `ODSFlyoutMenu-Content-${H}`,
              a
            ),
            style: { ...O },
            "data-scheme": L,
            "data-mode": _,
            "data-state": f ? "open" : "closed",
            "data-nested": v ? "" : void 0,
            ...$({
              ...m,
              onKeyDown: (h) => {
                var R;
                B(h), (R = m.onKeyDown) == null || R.call(
                  m,
                  h
                );
              }
            }),
            children: P
          }
        )
      }
    ) }) }) })
  ] });
});
U.displayName = "ODSFlyoutMenuContent";
const xe = y.forwardRef((s, c) => {
  const {
    className: a,
    label: u,
    disabled: e,
    helperText: r,
    startSlot: d,
    endSlot: D,
    iconBefore: p,
    iconAfter: M,
    onSelect: m,
    size: F,
    ...t
  } = s, l = q(), f = K({ label: e ? null : u }), S = A(), g = z([f.ref, c]), O = f.index === l.activeIndex, x = (o) => {
    m == null || m(o), o.defaultPrevented || S == null || S.events.emit("click");
  }, b = p ?? d, I = M ?? D;
  return /* @__PURE__ */ w(
    "div",
    {
      ref: g,
      role: "menuitem",
      tabIndex: O ? 0 : -1,
      "aria-disabled": e ? "true" : void 0,
      "data-disabled": e ? "" : void 0,
      className: T("ODSFlyoutMenu-Item", a),
      ...t,
      ...l.getItemProps({
        onClick(o) {
          var n;
          e || ((n = t.onClick) == null || n.call(t, o), x(o));
        },
        onKeyDown(o) {
          var n;
          e || (o.key === "Enter" && x(o), (n = t.onKeyDown) == null || n.call(t, o));
        },
        onFocus(o) {
          var n;
          e || ((n = t.onFocus) == null || n.call(t, o), l.setHasFocusInside(!0));
        }
      }),
      children: [
        b && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${F}`,
            children: b
          }
        ),
        /* @__PURE__ */ w("span", { className: "ODSFlyoutMenu-ItemLabel", children: [
          u,
          r && /* @__PURE__ */ i(
            "span",
            {
              className: "ODSFlyoutMenu-ItemHelperText",
              "data-disabled": e ? "" : void 0,
              children: r
            }
          )
        ] }),
        I && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${F}`,
            children: I
          }
        )
      ]
    }
  );
});
xe.displayName = "ODSFlyoutMenuItem";
const Ne = y.forwardRef((s, c) => {
  const {
    className: a,
    label: u,
    disabled: e,
    helperText: r,
    startSlot: d,
    endSlot: D,
    iconBefore: p,
    iconAfter: M,
    size: m,
    onSelect: F,
    ...t
  } = s, l = q(), f = K({ label: e ? null : u }), S = A(), g = z([f.ref, c]), O = f.index === l.activeIndex, x = (o) => {
    F == null || F(o), o.defaultPrevented || S == null || S.events.emit("click");
  }, b = p ?? d, I = M ?? D;
  return /* @__PURE__ */ w(
    "a",
    {
      ref: g,
      role: "menuitem",
      tabIndex: O ? 0 : -1,
      "aria-disabled": e ? "true" : void 0,
      "data-disabled": e ? "" : void 0,
      className: T("ODSFlyoutMenu-Item", "ODSFlyoutMenu-ItemLink", a),
      ...t,
      ...l.getItemProps({
        onClick(o) {
          var n;
          if (e) {
            o.preventDefault();
            return;
          }
          (n = t.onClick) == null || n.call(t, o), x(o);
        },
        onKeyDown(o) {
          var n;
          if (e) {
            o.preventDefault();
            return;
          }
          (n = t.onKeyDown) == null || n.call(t, o);
        },
        onFocus(o) {
          var n;
          e || ((n = t.onFocus) == null || n.call(t, o), l.setHasFocusInside(!0));
        }
      }),
      children: [
        b && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${m}`,
            children: b
          }
        ),
        /* @__PURE__ */ w("span", { className: "ODSFlyoutMenu-ItemLabel", children: [
          u,
          r && /* @__PURE__ */ i(
            "span",
            {
              className: "ODSFlyoutMenu-ItemHelperText",
              "data-disabled": e ? "" : void 0,
              children: r
            }
          )
        ] }),
        I && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${m}`,
            children: I
          }
        )
      ]
    }
  );
});
Ne.displayName = "ODSFlyoutMenuItemLink";
const ve = y.forwardRef((s, c) => {
  const {
    className: a,
    label: u,
    disabled: e,
    textValue: r,
    helperText: d,
    startSlot: D,
    iconBefore: p,
    checked: M,
    size: m,
    onCheckedChange: F,
    onSelect: t,
    ...l
  } = s, f = q(), g = K({ label: e ? null : r ?? u }), O = A(), x = z([g.ref, c]), b = g.index === f.activeIndex, I = (n) => {
    t == null || t(n), F == null || F(!M), n.defaultPrevented || O == null || O.events.emit("click");
  }, o = p ?? D;
  return /* @__PURE__ */ w(
    "div",
    {
      ref: x,
      role: "menuitemcheckbox",
      tabIndex: b ? 0 : -1,
      "aria-checked": M,
      "data-disabled": e ? "" : void 0,
      className: T("ODSFlyoutMenu-Item", a),
      ...l,
      ...f.getItemProps({
        onClick(n) {
          var N;
          e || ((N = l.onClick) == null || N.call(l, n), I(n));
        },
        onKeyDown(n) {
          var N;
          e || (n.key === "Enter" && I(n), (N = l.onKeyDown) == null || N.call(l, n));
        },
        onFocus(n) {
          var N;
          e || ((N = l.onFocus) == null || N.call(l, n), f.setHasFocusInside(!0));
        }
      }),
      children: [
        o && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${m}`,
            children: o
          }
        ),
        /* @__PURE__ */ w("span", { className: "ODSFlyoutMenu-ItemLabel", children: [
          u,
          d && /* @__PURE__ */ i(
            "span",
            {
              className: "ODSFlyoutMenu-ItemHelperText",
              "data-disabled": e ? "" : void 0,
              children: d
            }
          )
        ] }),
        M && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${m}`,
            children: /* @__PURE__ */ i(Me, { decorative: !0, selected: !0 })
          }
        )
      ]
    }
  );
});
ve.displayName = "ODSFlyoutMenuItemCheckbox";
const ke = (s) => {
  const c = s.menuSize ?? s.size, { children: a, horizontalOffset: u = 0, trigger: e, ...r } = s, d = e ? y.cloneElement(e, {
    menuSize: c
  }) : void 0;
  return /* @__PURE__ */ i(
    W,
    {
      horizontalOffset: u,
      trigger: d,
      ...r,
      children: a
    }
  );
};
ke.displayName = "ODSFlyoutMenuSub";
const W = y.forwardRef((s, c) => /* @__PURE__ */ i(U, { ...s, ref: c }));
W.displayName = "ODSFlyoutMenuSubContent";
const Ce = y.forwardRef((s, c) => {
  const {
    className: a,
    label: u,
    disabled: e,
    helperText: r,
    startSlot: d,
    iconBefore: D,
    size: p,
    ...M
  } = s, m = z([c]), F = D ?? d;
  return /* @__PURE__ */ w(
    "div",
    {
      ref: m,
      className: T(
        "ODSFlyoutMenu-Item",
        `ODSFlyoutMenu-Item-${p}`,
        a
      ),
      ...M,
      children: [
        F && /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${p}`,
            children: F
          }
        ),
        /* @__PURE__ */ w("span", { className: "ODSFlyoutMenu-ItemLabel", children: [
          u,
          r && /* @__PURE__ */ i(
            "span",
            {
              className: "ODSFlyoutMenu-ItemHelperText",
              "data-disabled": e ? "" : void 0,
              children: r
            }
          )
        ] }),
        /* @__PURE__ */ i(
          "span",
          {
            "aria-hidden": "true",
            className: `ODSFlyoutMenu-ItemIcon ODSFlyoutMenu-ItemIcon-${p}`,
            children: /* @__PURE__ */ i(ge, { decorative: !0, selected: !0 })
          }
        )
      ]
    }
  );
});
Ce.displayName = "ODSFlyoutMenuSubTrigger";
function we({
  defaultOpen: s = !1,
  open: c,
  onOpenChange: a,
  loop: u = !1,
  disabled: e = !1,
  verticalOffset: r = 0,
  horizontalOffset: d = 0,
  openOnHover: D = !1
} = {}) {
  var G;
  const [p, M] = y.useState(s), [m, F] = y.useState(!1), [t, l] = y.useState(null), f = c ?? p, S = a ?? M, g = y.useRef([]), O = y.useRef([]), x = ae(), b = le(), I = b != null, o = J("(max-width: 640px)"), n = I && !o ? "right-start" : "bottom-start", N = () => I ? {
    mainAxis: o ? r : d,
    alignmentAxis: o ? -d : r
  } : { mainAxis: r, alignmentAxis: d }, $ = J("(max-width:319px)"), { floatingStyles: v, refs: k, context: C, ...E } = ie({
    nodeId: x,
    strategy: "absolute",
    whileElementsMounted: de,
    placement: n,
    middleware: [
      ce(N),
      !$ && ue({ padding: d }),
      re({
        apply({ elements: Y, availableHeight: Z }) {
          Object.assign(Y.floating.style, {
            maxHeight: `${Math.max(Z, 140)}px`
          });
        },
        padding: d
      })
    ],
    open: f,
    onOpenChange: S
  }), H = ((G = E.elements.reference) == null ? void 0 : G.ariaDisabled) !== "true", L = me(C, {
    enabled: D || I && H,
    delay: { open: 75 },
    handleClose: fe({ blockPointerEvents: !0 })
  }), _ = ye(C, {
    enabled: c == null,
    toggle: !I,
    ignoreMouse: I
  }), B = Fe(C, { role: "menu" }), P = Ie(C, {
    bubbles: !0,
    /**
     * This is handled in the content component,
     * to ensure the Esc key only closes the current submenu
     * and not the entire nested tree.
     * @see https://www.w3.org/WAI/ARIA/apg/patterns/menubar/
     */
    escapeKey: !1,
    outsidePressEvent: "mousedown"
  }), h = Se(C, {
    listRef: g,
    activeIndex: t,
    nested: I,
    onNavigate: l,
    loop: u
  }), R = he(C, {
    listRef: O,
    onMatch: f ? l : void 0,
    activeIndex: t
  }), { getReferenceProps: Q, getFloatingProps: V, getItemProps: X } = De(
    [L, _, B, P, h, R]
  );
  return y.useMemo(
    () => ({
      open: f,
      setOpen: S,
      disabled: e,
      getReferenceProps: Q,
      getFloatingProps: V,
      getItemProps: X,
      floatingStyles: v,
      refs: k,
      context: C,
      nodeId: x,
      parentId: b,
      elementsRef: g,
      labelsRef: O,
      activeIndex: t,
      setActiveIndex: l,
      hasFocusInside: m,
      setHasFocusInside: F
    }),
    [
      f,
      S,
      e,
      Q,
      V,
      X,
      v,
      k,
      C,
      x,
      b,
      g,
      O,
      t,
      m
    ]
  );
}
const j = y.createContext(null), q = () => {
  const s = y.useContext(j);
  if (s == null)
    throw new Error(
      "Flyout Menu components must be wrapped in <ODSFlyoutMenu />"
    );
  return s;
};
function Re({
  nodeId: s,
  parentId: c,
  tree: a,
  open: u,
  setOpen: e
}) {
  y.useEffect(() => {
    if (!a) return;
    const r = () => {
      e(!1);
    }, d = (D) => {
      D.nodeId !== s && D.parentId === c && e(!1);
    };
    return a.events.on("click", r), a.events.on("menuopen", d), () => {
      a.events.off("click", r), a.events.off("menuopen", d);
    };
  }, [a, e, s, c]), y.useEffect(() => {
    u && a && a.events.emit("menuopen", { parentId: c, nodeId: s });
  }, [a, u, s, c]);
}
export {
  be as O,
  xe as a,
  Ne as b,
  ve as c,
  ke as d,
  Ce as e,
  U as f
};
//# sourceMappingURL=ODSFlyoutMenu.DtVb_yUM.js.map
